<template>
  <b-nav-item-dropdown right id="notification-dropdown">
    <template slot="button-content">
      <div class="notification" :class="{'show-count': showCounter }" :data-count="notificationsCounter()" ></div>
    </template>
    <b-dropdown-item v-show="showCounter" @click="markAllRead">Mark All Read</b-dropdown-item>
    <b-dropdown-item-button v-show="showCounter" v-for="notification in notifications" :key="notification.id" href="#" @click="markAsRead(notification)" v-html="notification.content"></b-dropdown-item-button>
    <b-dropdown-item v-if="!showCounter">No Notifications</b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
export default {
  name: 'Notifications',

  data () {
    return {
      interval: null
    }
  },

  created () {
    this.loadNotifications()
  },

  methods: {
    ...mapActions(['loadNotifications']),
    ...mapMutations(['setNotifications']),
    notificationsCounter () {
      return this.notifications.length.toString()
    },

    markAsRead (notification) {
      var notificationObject = notification
      notification.read = true
      this.$http.put('/notifications/' + notification.id, {notification: notificationObject})
        .then((response) => {
          this.setNotifications(response.data)
        })
        .catch(e => { console.log(e) })
    },

    markAllRead () {
      this.$http.put('/notifications/0', {all_notifications: true})
        .then((response) => {
          this.setNotifications(response.data)
        })
        .catch(e => { console.log(e) })
    }
  },

  computed: {
    showCounter () {
      return this.notifications.length > 0
    },
    ...mapGetters(['notifications'])
  }
}
</script>
<style scoped>
/* Notifications */

.notification {
  display: inline-block;
  position: relative;
  font-size: 1.3em;
}

.notification::before,
.notification::after {
  color: #fff;
  opacity: .5;
}
.notification:hover::before,
.notification:hover::after {
  opacity: 1;
}

.notification::before {
  display: block;
  content: "\e01d";
  font-family: "Icons";
  transform-origin: top center;
}

.notification::after {
  font-family: Arial;
  font-size: 0.7em;
  font-weight: 700;
  position: absolute;
  top: -15px;
  right: -25px;
  padding: 5px 8px;
  line-height: 100%;
  border: 2px #fff solid;
  border-radius: 60px;
  background: #57B2CD;
  opacity: 0;
  content: attr(data-count);
  opacity: 0;
  -webkit-transform: scale(0.5);
  transform: scale(0.5);
  transition: transform, opacity;
  transition-duration: 0.3s;
  transition-timing-function: ease-out;
}

.notification.notify::before {
  -webkit-animation: ring 1.5s ease;
  animation: ring 1.5s ease;
}

.notification.show-count::after {
  -webkit-transform: scale(1);
  transform: scale(1);
  opacity: 1;
}

button:focus {
  outline: none;
}

@-webkit-keyframes ring {
  0% {
    -webkit-transform: rotate(35deg);
  }
  12.5% {
    -webkit-transform: rotate(-30deg);
  }
  25% {
    -webkit-transform: rotate(25deg);
  }
  37.5% {
    -webkit-transform: rotate(-20deg);
  }
  50% {
    -webkit-transform: rotate(15deg);
  }
  62.5% {
    -webkit-transform: rotate(-10deg);
  }
  75% {
    -webkit-transform: rotate(5deg);
  }
  100% {
    -webkit-transform: rotate(0deg);
  }
}

@keyframes ring {
  0% {
    -webkit-transform: rotate(35deg);
    transform: rotate(35deg);
  }
  12.5% {
    -webkit-transform: rotate(-30deg);
    transform: rotate(-30deg);
  }
  25% {
    -webkit-transform: rotate(25deg);
    transform: rotate(25deg);
  }
  37.5% {
    -webkit-transform: rotate(-20deg);
    transform: rotate(-20deg);
    }
  50% {
    -webkit-transform: rotate(15deg);
    transform: rotate(15deg);
  }
  62.5% {
    -webkit-transform: rotate(-10deg);
    transform: rotate(-10deg);
  }
  75% {
    -webkit-transform: rotate(5deg);
    transform: rotate(5deg);
  }
  100% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
}
</style>

<style>
#notification-dropdown .dropdown-menu {
    overflow-y: scroll;
    max-height: 80vh;
    width: 60vw;
}
</style>



// WEBPACK FOOTER //
// src/components/Notifications.vue